import { memo } from "react";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import LinkTab from "layouts/components/LinkTab";

import Destinations from "./Destinations";
import Sources from "./Sources";

// -----------------------------------------------------------------------------

const EnvironmentPage = memo(function EnvironmentPage({
  tab,
}: EnvironmentPageProps): JSX.Element {
  const moduleId = getModuleId(tab);

  //
  return (
    <>
      <Typography gutterBottom variant="h4" fontWeight="bold">
        Environment
      </Typography>

      <Tabs value={moduleId}>
        <LinkTab label="Sources" to="/environment/sources" />
        <LinkTab label="Destinations" to="/environment/destinations" />
      </Tabs>

      <Box sx={{ mt: 3 }}>{renderTab(moduleId)}</Box>
    </>
  );
});

export default EnvironmentPage;

// -----------------------------------------------------------------------------

function renderTab(value: number): JSX.Element {
  switch (value) {
    case 0:
      return <Sources />;

    case 1:
      return <Destinations />;

    default:
      return <Sources />;
  }
}

function getModuleId(module: string): number {
  switch (module) {
    case "destinations":
      return 1;

    default:
      return 0;
  }
}

// -----------------------------------------------------------------------------

interface EnvironmentPageProps {
  tab: "sources" | "destinations";
}
